
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import * as _moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { KpitargetService } from 'src/app/services/kpitraget.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
const moment = _moment;

@Component({
  selector: 'app-kpi-target-download',
  templateUrl: './kpi-target-download.component.html',
  styleUrls: ['./kpi-target-download.component.scss']
})
export class KpiTargetDownloadComponent implements OnInit {
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  KpiForm!: FormGroup;

  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  menuBlueIconUrl = 'assets/images/menu-bottom-blue-icon.png';

  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredFrequency: any;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  frequencyList!: any[];
  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridApiEdit: any;
  gridColumnApi: any;
  gridColumnApiEdit: any;
  public excelStyles!: any;
  key: any;
  OutputLoses!: any;
  window: any;
  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,     // <-- HERE
      autoHeight: true,   // <-- & HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  lang: any

  constructor(
    private formBuilder: FormBuilder,
    private kpiMaster: KpimasterService,
    private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private productivityservice: ProductivityService,
    private kpiService: KpitargetService,
    private kpiMasterService: KpimasterService,
    private spinner: NgxSpinnerService,
    public router: Router,
    public translater: TranslaterService,
    public translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
    this.columnDefs = [
      { headerName: 'Date', field: 'Date', filter: 'agTextColumnFilter', valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('MM/DD/YYYY HH:mm:ss ') : '' }, headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'KPI Code', field: 'KPICode', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'KPI Name', field: 'KPIName', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Target', field: 'Target', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'UOM', field: 'UOM', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Year', field: 'Year', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'FrequencyName', field: 'frequencyName', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Shift', field: 'Shift', filter: 'agTextColumnFilter', headerValueGetter: this.localizeHeader.bind(this) },
    ],
      this.excelStyles = [
        {
          id: 'header',
          interior: {
            color: '#a47ed9',
            pattern: 'Solid',
          },
        },
        {
          id: 'body',
          interior: {
            color: '#d1c1e8',
            pattern: 'Solid',
          },
        },
      ];
  }

  ngOnInit(): void {
    this.initForm();
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.datasource();
  }
  initForm() {
    const dateStart = new Date();
    //dateStart.setDate(dateStart.getDate() - 183);
    dateStart.setHours(6);
    dateStart.setMinutes(0);
    dateStart.setSeconds(0);


    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());

    this.KpiForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      year: ['', Validators.required],
      frequency: ['']
    });
  }

  onChangeGroup(data: any): void {
    this.getPlants(data);
  }
  onChangePlant(): void {
    this.getMasterFrequencies();
  }


  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
      }
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
      console.log(data.BreadcrumList);
      this.getLangWords();
      this.lang = new Multilingual(this.translater,this.translate);
      this.lang.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }

  datasource(): void {
    const key = {
      UserId: 206     //later it will be change this is only for testing
    };
    const id = {
      value: 0
    };
    this.productivityservice.getGroupData(key).subscribe((data: any) => {
      this.GroupList = data.lstEG;
      if (this.GroupList.length > 0) {
        id.value = data.lstEG[0].EG_Id;
        this.KpiForm.get('UserGroup1')?.setValue(data.lstEG[0].EG_Id);
        this.KpiForm.get('UserPlant1')?.setValue(data.lstEG[0].EG_Id);
        this.filteredGroups = this.GroupList.slice();
        this.getPlants(id);
      }
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: event.value,
      userId: 206
    };
    this.productivityservice.getPlantsData(key).subscribe((data: any) => {
      this.PlantList1 = data.lstPlant;
      if (this.PlantList1.length > 0) {
        const id = data.lstPlant[0].PT_Id;
        this.KpiForm.get('UserPlant1')?.patchValue(id);
        this.filteredPlants = this.PlantList1.slice();
        this.getMasterFrequencies();
      }
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }
  getMasterFrequencies() {
    const key = {
      plantId: this.KpiForm.get('UserPlant1')?.value,

    };
    this.kpiMasterService.getMasterFrequencies(key).subscribe((data: any) => {
      this.frequencyList = data;
      this.filteredFrequency = this.frequencyList.slice();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }


  onSubmit(): void {
    const key = {
      PlantId: this.KpiForm.get('UserPlant1')?.value,
      year: moment(this.KpiForm.get('year')?.value).format('YYYY'),
      frequency: this.KpiForm.get('frequency')?.value,
    };
    this.kpiService.getTargets(key).subscribe((data: any) => {
      this.rowData = data.kPIResultsDTOs;
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }



  nFormatter(num: any, digits: any) {

    if (digits === undefined) {
      digits = 1;
    }
    var si = [
      { value: 1, symbol: "" },
      { value: 1E3, symbol: " K" },
      { value: 1E6, symbol: " M" },
      { value: 1E9, symbol: " G" },
      { value: 1E12, symbol: " T" },
      { value: 1E15, symbol: " P" },
      { value: 1E18, symbol: " E" }
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  }


  //========================================================= AG Grid ====================================================//

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  excelExport() {
    let params: any = {
      columnKeys: ['Date', 'KPICode', 'KPIName', 'Target', 'UOM', 'Year', 'frequencyName', 'Shift'],
      allColumns: false,
      skipHeader: false,
      //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
    };
    params.processCellCallback = function (cellParams: any) {
      if (cellParams && cellParams.column.colId === 'Date')
        return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
      else
        return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsExcel();
  }
  csvExport() {
    let params: any = {
      columnKeys: ['Date', 'KPICode', 'KPIName', 'Target', 'UOM', 'Year', 'frequencyName', 'Shift'],
      allColumns: false,
      skipHeader: false,
      //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
    };
    params.processCellCallback = function (cellParams: any) {
      if (cellParams && cellParams.column.colId === 'Date')
        return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
      else
        return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params);
  }


}
